import { Component, Input, Output, EventEmitter } from '@angular/core';
import { SeparatedDocument } from '../../models/file-review.model';

@Component({
  selector: 'separated-files-sidebar',
  templateUrl: './separated-files-sidebar.component.html',
  styleUrls: ['./separated-files-sidebar.component.scss']
})
export class SeparatedFilesSidebarComponent {

  @Input() separated_documents: SeparatedDocument[] = [];
  @Input() selected_doc_id: string | null = null;
  @Input() approved_count: number = 0;
  @Input() total_count: number = 0;

  @Output() docSelected = new EventEmitter<string>();

  /**
   * Handles the selection of a document from the sidebar
   * @param doc_id - The ID of the selected document
   */
  selectDocument(doc_id: string): void {
    this.docSelected.emit(doc_id);
  }

  /**
   * Checks if a document is currently selected
   * @param doc_id - The ID of the document to check
   * @returns True if the document is selected
   */
  isSelected(doc_id: string): boolean {
    return this.selected_doc_id === doc_id;
  }

}
